import { Menu, Phone } from "lucide-react";
import { Container } from "../container/container";
import { DialogForm } from "../dialog-form/dialog-form";
import { Logo } from "../logo/logo";
import { Button } from "../ui/button/button";
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetTrigger,
} from "../ui/sheet/sheet";
import { ModeToggle } from "../mode-toggle/mode-toggle";

export const Header = () => {
  const menuList = [
    {
      title: "Акции",
      anchor: "#offers",
    },
    {
      title: "Преимущества",
      anchor: "#advantages",
    },
    {
      title: "Планировки",
      anchor: "#flats",
    },
    // {
    //   title: 'Расположение',
    //   anchor: '#location',
    // },
    // {
    //   title: 'Паркинг',
    //   anchor: '#parking',
    // },
    // {
    //   title: 'О застройщике',
    //   anchor: '#developer',
    // },
    {
      title: "Контакты",
      anchor: "#contacts",
    },
  ];

  return (
    <header className="py-[36px] bg-gradient-to-b from-[#2E3844] to-transparent fixed top-0 left-0 w-full z-50">
      <Container>
        <div className="flex justify-between items-center">
          <DialogForm
            title="Закажите обратный звонок"
            description="отправьте заявку, наш менеджер свяжется с Вами"
          >
            <button className="px-5 py-[10px] bg-[#c6263d] text-white rounded-lg h-fit w-fit font-bold hidden screen-1050:block">
              <Phone size={16} />
            </button>
          </DialogForm>
          <Logo className="mx-5" />
          <div className="screen-1050:hidden">
            <nav>
              <ul className="flex gap-5 font-gilroy text-plt-white">
                {menuList.map((item) => (
                  <li key={item.title}>
                    <a href={`/${item.anchor}`}>{item.title}</a>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          <div className="flex items-center gap-20 screen-1050:hidden">
            <a className="text-white font-bold" href="tel:74232100243">
              8 (423) 210-02-43
            </a>
            <div className="flex gap-2">
              <ModeToggle />
              <DialogForm
                title="Закажите обратный звонок"
                description="отправьте заявку, наш менеджер свяжется с Вами"
              >
                <Button>Заказать звонок</Button>
              </DialogForm>
            </div>
          </div>
          <div className="hidden screen-1050:flex gap-2">
            <ModeToggle />
            <Sheet>
              <SheetTrigger asChild>
                <Button className="">
                  <Menu />
                </Button>
              </SheetTrigger>
              <SheetContent side={"top"}>
                <ul className="grid gap-2">
                  {menuList.map((item) => (
                    <li key={item.title} className="text-xl font-semibold">
                      <SheetClose asChild>
                        <a href={item.anchor}>{item.title}</a>
                      </SheetClose>
                    </li>
                  ))}
                </ul>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </Container>
    </header>
  );
};
